<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { formatDate } from 'utils/dateutils';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { getAdvHedgeAppList } from 'api/billing/advertiser/advHedgeApplicationAPI';
  import AdvHedgeAppBaseForm from '@/views/billing/advertiser/forms/AdvHedgeAppBaseForm.vue';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { splitStrByLineBreak } from 'utils/string';

  export default {
    name: 'AdvDeductionApp',
    components: {
      AdvHedgeAppBaseForm,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, financeInfoMixins],
    data() {
      return {
        dialogVisible: false,
        dialogType: 'new',
        total: 0,
        listLoading: false,
        dataList: [],
        auditStatus: null,
        filter: {
          page: 1,
          pageSize: 10,
          advCompanyPlatform: null,
          advEntity: null,
          hyperTapEntity: null,
          auditStatus: null,
          receiptStatus: null,
          advHedgeAppNumber: null,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      splitStrByLineBreak,
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },

      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleCreate() {
        this.dialogType = 'new';
        this.dialogVisible = true;
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAdvHedgeAppList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      handleApprovalForm(dialogType, auditStatus) {
        this.dialogType = dialogType;
        this.auditStatus = auditStatus;
        this.dialogVisible = true;
        this.editData = {};
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Adv Hedge Management'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Application Number">
          <el-input v-model="filter.advHedgeAppNumber" clearable />
        </el-form-item>
        <el-form-item label="Company Platform">
          <el-select
            v-model="filter.advCompanyPlatform"
            filterable
            clearable
            placeholder="please select"
            @change="handleCompanyPlatformChange(filter.advCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Entity">
          <el-select
            v-model="filter.advEntity"
            ref="companyEntityOptions"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.hyperTapEntity"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.companyEntity"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Receipt Status">
          <el-select
            v-model="filter.receiptStatus"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in advHedgeAppReceiptStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Application Status">
          <el-select v-model="filter.auditStatus" filterable clearable placeholder="please select">
            <el-option
              v-for="item in affHedgeAppAuditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">Create</el-button>
      <el-button type="success" @click="handleApprovalForm('status', 'APPROVED')"
        >Approve</el-button
      >
      <el-button type="warning" @click="handleApprovalForm('status', 'REJECTED')"
        >UnApprove</el-button
      >
      <el-button type="primary" @click="handleApprovalForm('status', 'AUTO_RECEIPT')"
        >Auto Receipt</el-button
      >
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Adv Hedge Application Number"
          prop="advHedgeAppNumber"
          fixed="left"
          align="center"
          width="240"
          key="advHedgeAppNumber"
        />
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          key="recordStartDate"
        />

        <el-table-column
          label="Company Platform"
          prop="advCompanyPlatform"
          align="center"
          min-width="170"
          key="companyPlatform"
        />
        <el-table-column
          label="Adv Entity"
          prop="advEntity"
          show-overflow-tooltip
          align="center"
          width="170"
          key="advEntity"
        />

        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          key="hyperTapEntity"
          width="160"
        >
          <template #default="scope">
            {{ getHyperTapCompanyAlias(scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Hedge App Number"
          prop="affHedgeAppNumber"
          align="center"
          key="affHedgeAppNumber"
          width="220"
        >
          <template #default="scope">
            <el-link
              v-for="(item, index) in splitStrByLineBreak(scope.row.affHedgeAppNumber, ';')"
              :key="index"
              @click="$copyText(item).then($message.success('复制成功'))"
              >{{ item }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Receipt Claim Number"
          prop="advReceiptClaimNumber"
          align="center"
          key="advReceiptClaimNumber"
          width="220"
        >
          <template #default="scope">
            <el-link
              v-for="(item, index) in splitStrByLineBreak(scope.row.advReceiptClaimNumber, ';')"
              :key="index"
              @click="$copyText(item).then($message.success('复制成功'))"
              >{{ item }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Revenue"
          prop="advRevenue"
          align="center"
          key="advRevenue"
          width="140"
          sortable="custom"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          prop="advConfirmedAmount"
          align="center"
          key="advConfirmedAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Aff Hedge Amount"
          prop="affHedgeAmount"
          align="center"
          key="affHedgeAmount"
          width="180"
        />
        <el-table-column
          label="Adv Hedge Amount"
          prop="advHedgeAmount"
          align="center"
          key="advHedgeAmount"
          width="180"
          sortable="custom"
        />
        <el-table-column
          label="Apply Hedge Amount"
          prop="applyHedgeAmount"
          align="center"
          key="applyHedgeAmount"
          width="180"
        />
        <el-table-column
          label="Application Status"
          prop="auditStatus"
          align="center"
          key="auditStatus"
          width="240"
          fixed="right"
        >
          <template #default="scope">
            {{ getEnumLabel(advHedgeAppAuditStatusList, scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Status"
          prop="receiptStatus"
          align="center"
          key="receiptStatus"
          width="170"
        >
          <template #default="scope">
            {{ getEnumLabel(advHedgeAppReceiptStatusList, scope.row.receiptStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Remark"
          prop="remark"
          :show-overflow-tooltip="true"
          align="center"
          key="remark"
          width="250"
        />
        <el-table-column
          label="Audit Remark"
          prop="auditRemark"
          :show-overflow-tooltip="true"
          align="center"
          key="auditRemark"
          width="250"
        />
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
        <el-table-column
          label="Update Time"
          prop="updateTime"
          align="center"
          key="updateTime"
          width="160"
        />
        <el-table-column
          label="Update By"
          prop="updateBy"
          align="center"
          key="updateBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
    <template #dialog>
      <adv-hedge-app-base-form
        :dialogVisible.sync="dialogVisible"
        :dialog-type="dialogType"
        :auditStatus.sync="auditStatus"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
